module.exports = __webpack_public_path__ + "static/media/premium2.954d75ae.jpg";